/* Fragrances Bazaar – Smell the World. Theme JS. Vanilla, no dependencies. */
(() => {
  if (window.__fbTheme) return;
  window.__fbTheme = true;

  const FB = window.FBTheme || { routes: {}, strings: {}, motion: {} };
  const R = FB.routes || {};
  const STR = FB.strings || {};
  const MOTION = FB.motion || {};
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = matchMedia('(pointer: fine)').matches;
  const DESIGN = !!(window.Shopify && window.Shopify.designMode);
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const lerp = (a, b, t) => a + (b - a) * t;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const once = (el, key) => { if (!el || el.dataset[key]) return false; el.dataset[key] = '1'; return true; };
  const body = document.body;
  const html = document.documentElement;
  const parse = txt => new DOMParser().parseFromString(txt, 'text/html');
  const sectionIdOf = el => { const s = el && el.closest('.shopify-section'); return s ? s.id.replace('shopify-section-', '') : null; };

  /* ---------- money (Shopify money_format) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || FB.moneyFormat || '${{amount}}';
    const fmt = (n, d = 2, t = ',', dec = '.') => {
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(d);
      const p = n.split('.');
      return p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (p[1] ? dec + p[1] : '');
    };
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return format;
    let v;
    switch (m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(m[0], v);
  }

  /* ---------- scroll lock helpers ---------- */
  let locks = 0;
  const lock = () => { locks++; body.style.overflow = 'hidden'; };
  const unlock = () => { locks = Math.max(0, locks - 1); if (!locks) body.style.overflow = ''; };
  function trapFocus(container, e) {
    if (e.key !== 'Tab') return;
    const f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])', container).filter(x => x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* =========================================================
     HEADER: overlay, scroll state, mega menu, mobile drawer
     ========================================================= */
  function setAnnH() {
    const a = $('.section-announcement');
    html.style.setProperty('--ann-h', (a ? a.offsetHeight : 0) + 'px');
  }
  function onHeaderScroll() {
    const hdr = $('#hdr'); if (!hdr) return;
    const y = scrollY;
    const over = hdr.classList.contains('is-over');
    const annH = over ? (parseFloat(getComputedStyle(html).getPropertyValue('--ann-h')) || 0) : 0;
    hdr.classList.toggle('is-fixed', y > Math.max(40, annH));
    hdr.classList.toggle('is-solid', y > 40);
  }
  /* Nav fit (priority+): when the menu does not fit on one line between the logo and the tools, first hide the
     quiz pill, then move items from the end into a "More" dropdown, and only collapse to the burger when fewer than
     3 items would remain. Handles 7+ menu items at any width. CSS (<=1320px burger, overflow clip) is the no-JS fallback. */
  function fitNav() {
    const hdr = $('#hdr'); if (!hdr) return;
    const nav = $('.hdr nav', hdr), ul = $('#nav', hdr), more = $('[data-nav-more]', hdr), list = $('[data-nav-more-list]', hdr);
    if (!nav || !ul) return;
    const items = $$(':scope > li', ul).filter(li => li !== more);
    hdr.classList.add('hdr--measuring');
    hdr.classList.remove('hdr--collapsed', 'hdr--nopill');
    items.forEach(li => li.classList.remove('is-overflow'));
    if (more) { more.classList.remove('is-on', 'open'); if (list) list.innerHTML = ''; }
    const done = () => hdr.classList.remove('hdr--measuring');
    if (getComputedStyle(nav).display === 'none') return done(); /* CSS breakpoint already shows the burger */
    const gap = parseFloat(getComputedStyle(ul).columnGap) || 0;
    const need = () => $$(':scope > li', ul).filter(li => getComputedStyle(li).display !== 'none').reduce((w, li, i) => w + li.getBoundingClientRect().width + (i ? gap : 0), 0);
    const fits = () => need() <= nav.clientWidth + 0.5;
    if (fits()) return done();
    hdr.classList.add('hdr--nopill');
    if (fits()) return done();
    if (more) more.classList.add('is-on');
    const hidden = [];
    for (let i = items.length - 1; i >= 0 && !fits(); i--) {
      if (items.length - hidden.length <= 3) break;
      items[i].classList.add('is-overflow'); hidden.unshift(items[i]);
    }
    if (!fits() || !more || !list) {
      items.forEach(li => li.classList.remove('is-overflow'));
      if (more) more.classList.remove('is-on');
      hdr.classList.add('hdr--collapsed');
      return done();
    }
    hidden.forEach(li => {
      const a = li.querySelector('.nav__a'); if (!a) return;
      const item = document.createElement('li'); const c = document.createElement('a');
      c.href = a.getAttribute('href') || '#'; c.textContent = a.textContent.trim();
      if (a.hasAttribute('aria-current')) c.setAttribute('aria-current', 'page');
      item.appendChild(c); list.appendChild(item);
    });
    done();
  }
  function initNavMore() {
    const more = $('[data-nav-more]'); if (!more || !once(more, 'fbMore')) return;
    const btn = more.querySelector('button'); let t;
    const set = on => { more.classList.toggle('open', on); btn.setAttribute('aria-expanded', on); };
    btn.addEventListener('click', () => set(!more.classList.contains('open')));
    more.addEventListener('mouseenter', () => { if (FINE) { clearTimeout(t); set(true); } });
    more.addEventListener('mouseleave', () => { clearTimeout(t); t = setTimeout(() => set(false), 160); });
    more.addEventListener('focusout', e => { if (!more.contains(e.relatedTarget)) set(false); });
    more.addEventListener('keydown', e => { if (e.key === 'Escape') { set(false); btn.focus(); } });
  }
  function initHeader() {
    setAnnH(); onHeaderScroll(); initNavMore(); fitNav();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitNav);
    const li = $('.logo img', $('#hdr') || document); if (li && !li.complete) li.addEventListener('load', fitNav, { once: true });
    $$('.nav .has-mega').forEach(li => {
      if (!once(li, 'fbMega')) return;
      const a = li.querySelector('.nav__a'); let t;
      const close = (el = li) => { el.classList.remove('open'); const x = el.querySelector('.nav__a'); if (x) x.setAttribute('aria-expanded', 'false'); };
      const open = () => { clearTimeout(t); $$('.nav .open').forEach(o => o !== li && close(o)); li.classList.add('open'); a.setAttribute('aria-expanded', 'true'); };
      li.addEventListener('mouseenter', () => { if (FINE) t = setTimeout(open, 90); });
      li.addEventListener('mouseleave', () => { clearTimeout(t); t = setTimeout(() => close(), 160); });
      a.addEventListener('click', e => { if (!FINE || e.detail === 0) { if (!li.classList.contains('open')) { e.preventDefault(); open(); } else if (e.detail === 0) { e.preventDefault(); close(); } } });
      li.addEventListener('focusout', e => { if (!li.contains(e.relatedTarget)) close(); });
    });
    const drawer = $('#drawer'), burger = $('#burger'), dClose = $('#drawerClose');
    if (drawer && burger && once(drawer, 'fbDrawer')) {
      const openD = () => { drawer.classList.add('open'); burger.setAttribute('aria-expanded', 'true'); body.classList.add('drawer-open'); lock(); dClose && dClose.focus(); };
      const closeD = () => { if (!drawer.classList.contains('open')) return; drawer.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); body.classList.remove('drawer-open'); unlock(); burger.focus(); };
      burger.addEventListener('click', openD);
      dClose && dClose.addEventListener('click', closeD);
      $$('a', drawer).forEach(a => a.addEventListener('click', closeD));
      drawer.addEventListener('keydown', e => { if (e.key === 'Escape') closeD(); trapFocus(drawer, e); });
      drawer._close = closeD;
    }
  }
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    $$('.nav .open').forEach(li => { li.classList.remove('open'); const a = li.querySelector('.nav__a'); if (a) a.setAttribute('aria-expanded', 'false'); });
  });
  addEventListener('scroll', onHeaderScroll, { passive: true });
  addEventListener('resize', () => { setAnnH(); fitNav(); });

  /* =========================================================
     REVEALS
     ========================================================= */
  const revealOff = RM || MOTION.reveal === false || !('IntersectionObserver' in window);
  const io = revealOff ? null : new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
  function initReveals(root = document) {
    $$('.rv, .split', root).forEach(el => {
      if (el.closest('.hero')) return;
      if (revealOff || DESIGN) { el.classList.add('in'); return; }
      if (once(el, 'fbRv')) io.observe(el);
    });
  }

  /* =========================================================
     MAGNETIC + CURSOR
     ========================================================= */
  const magOn = FINE && !RM && MOTION.magnetic !== false;
  const curOn = FINE && !RM && MOTION.cursor !== false;
  function bindMagnetic(root = document) {
    if (!magOn) return;
    $$('[data-magnetic]', root).forEach(el => {
      if (!once(el, 'fbMag')) return;
      el.addEventListener('pointermove', e => {
        const r = el.getBoundingClientRect(); const x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2;
        el.style.transition = 'transform .25s cubic-bezier(.2,.7,.1,1), color .5s, box-shadow .5s';
        el.style.transform = `translate(${x * 0.28}px,${y * 0.38}px)`;
      });
      el.addEventListener('pointerleave', () => { el.style.transition = 'transform .9s cubic-bezier(.16,1,.3,1), color .5s, box-shadow .5s'; el.style.transform = ''; });
    });
  }
  const cur = $('#cursor'), dot = $('#cursorDot');
  let kx = -100, ky = -100, rx = -100, ry = -100;
  function bindCursor(root = document) {
    if (!curOn || !cur) return;
    $$('a, button, [role=button], [role=tab]', root).forEach(el => {
      if (!once(el, 'fbCur')) return;
      el.addEventListener('pointerenter', () => cur.classList.add(el.closest('[data-cursor=view]') ? 'is-view' : 'is-link'));
      el.addEventListener('pointerleave', () => cur.classList.remove('is-view', 'is-link'));
    });
  }
  if (curOn && cur && dot) {
    html.classList.add('has-cursor'); body.classList.add('has-cursor');
    addEventListener('pointermove', e => { kx = e.clientX; ky = e.clientY; dot.style.transform = `translate3d(${kx}px,${ky}px,0)`; }, { passive: true });
    (function c() { rx = lerp(rx, kx, 0.16); ry = lerp(ry, ky, 0.16); cur.style.transform = `translate3d(${rx}px,${ry}px,0)`; requestAnimationFrame(c); })();
    document.addEventListener('pointerleave', () => cur.classList.remove('is-view', 'is-link'));
  }

  /* =========================================================
     HERO: intro, parallax, WebGL smoke
     ========================================================= */
  let hero = null, heroBottles = [], heroCopy = null, mx = 0, my = 0, cx = 0, cy = 0;
  function initHero() {
    hero = $('[data-hero]');
    if (!hero) { heroBottles = []; return; }
    heroBottles = $$('.stage .bottle', hero).map(b => ({ el: b.querySelector('.bp'), d: +b.dataset.depth || 1 })).filter(b => b.el);
    heroCopy = $('.hero__copy', hero);
    if (once(hero, 'fbHero')) {
      /* Hero copy is visible by default (CSS). JS only adds .ready, which plays the one-shot intro keyframes.
         setTimeout (not requestAnimationFrame) so it still fires in background tabs; the 1.2s cap means slow fonts never hold it back. */
      const ready = () => { if (hero.classList.contains('ready')) return; hero.classList.add('ready'); $$('.rv, .split', hero).forEach(el => el.classList.add('in')); };
      (document.fonts && document.fonts.ready ? Promise.race([document.fonts.ready, new Promise(r => setTimeout(r, 1200))]) : Promise.resolve()).then(() => setTimeout(ready, 0), () => ready());
      setTimeout(ready, 1500);
      if (FINE && !RM) hero.addEventListener('pointermove', e => { mx = e.clientX / innerWidth - 0.5; my = e.clientY / innerHeight - 0.5; });
    }
    const cv = $('canvas[data-smoke]', hero);
    if (cv && once(cv, 'fbSmoke')) smoke(cv);
  }
  function tickHero() {
    if (!hero || !hero.isConnected) return;
    cx = lerp(cx, mx, 0.06); cy = lerp(cy, my, 0.06);
    const sy = Math.min(scrollY, innerHeight);
    if (sy > innerHeight * 1.2) return;
    heroBottles.forEach(b => { b.el.style.transform = `translate3d(${cx * 34 * b.d}px,${cy * 22 * b.d - sy * 0.18 * b.d}px,0) rotate(${cx * 3 * b.d}deg)`; });
    if (heroCopy) { heroCopy.style.transform = `translate3d(0,${sy * -0.08}px,0)`; heroCopy.style.opacity = 1 - Math.min(1, sy / (innerHeight * 0.9)) * 0.6; }
  }
  function smoke(cv) {
    let gl;
    try { gl = cv.getContext('webgl', { antialias: false, alpha: true, premultipliedAlpha: false, powerPreference: 'low-power' }); } catch (e) { gl = null; }
    if (!gl) { cv.remove(); return; }
    const vs = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
    const fs = `precision mediump float;uniform vec2 r;uniform float t;uniform vec2 m;
    float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
    float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1,0)),f.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),f.x),f.y);}
    float fb(vec2 p){float v=0.,a=.5;mat2 R=mat2(.8,.6,-.6,.8);for(int i=0;i<5;i++){v+=a*n(p);p=R*p*2.03;a*=.5;}return v;}
    void main(){vec2 uv=gl_FragCoord.xy/r;vec2 p=uv*vec2(r.x/r.y,1.)*1.45;
      p+=m*.18; float T=t*.035;
      vec2 q=vec2(fb(p+vec2(0.,-T*2.2)),fb(p+vec2(5.2,1.3)-T*.8));
      vec2 w=vec2(fb(p+2.8*q+vec2(1.7,9.2)+T*1.2),fb(p+2.8*q+vec2(8.3,2.8)-T));
      float f=fb(p+2.6*w+vec2(0.,-T*3.));
      vec3 ink=vec3(.082,.071,.11);vec3 plum=vec3(.17,.11,.17);vec3 gold=vec3(.89,.72,.40);vec3 rose=vec3(.62,.31,.24);
      vec3 c=mix(ink,plum,smoothstep(.25,.85,f)*.7);
      float wisp=pow(smoothstep(.5,.92,f),1.6);
      float focus=smoothstep(.95,.05,distance(uv*vec2(r.x/r.y,1.),vec2(.72*r.x/r.y,.45)));
      c+=gold*wisp*(.12+.32*focus)+rose*smoothstep(.5,.8,q.y)*.05*(1.-focus);
      c+=gold*focus*focus*.09;
      float vig=smoothstep(1.3,.2,distance(uv,vec2(.62,.48)));
      c=mix(ink*.85,c,vig);
      gl_FragColor=vec4(c,1.);}`;
    const sh = (type, src) => { const s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s)); return s; };
    let pr;
    try { pr = gl.createProgram(); gl.attachShader(pr, sh(gl.VERTEX_SHADER, vs)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, fs)); gl.linkProgram(pr); } catch (e) { cv.remove(); return; }
    gl.useProgram(pr);
    const b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    const loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    const ur = gl.getUniformLocation(pr, 'r'), ut = gl.getUniformLocation(pr, 't'), um = gl.getUniformLocation(pr, 'm');
    const SCALE = 0.5; let W = 1, H = 1;
    const size = () => { W = Math.max(1, Math.round(cv.clientWidth * SCALE)); H = Math.max(1, Math.round(cv.clientHeight * SCALE)); cv.width = W; cv.height = H; gl.viewport(0, 0, W, H); };
    size(); addEventListener('resize', size);
    let vis = true; new IntersectionObserver(es => { vis = es[0].isIntersecting; }).observe(cv);
    const t0 = performance.now(); let smx = 0, smy = 0;
    const draw = now => { smx = lerp(smx, cx, 0.05); smy = lerp(smy, cy, 0.05); gl.uniform2f(ur, W, H); gl.uniform1f(ut, RM ? 40 : (now - t0) / 1000 + 40); gl.uniform2f(um, smx, -smy); gl.drawArrays(gl.TRIANGLES, 0, 3); };
    if (RM) { draw(t0); addEventListener('resize', () => draw(t0)); return; }
    (function f(now) { if (!cv.isConnected) return; if (vis && document.visibilityState === 'visible') draw(now); requestAnimationFrame(f); })(t0);
  }

  /* =========================================================
     FRAGRANCE OF THE MONTH: parallax + pyramid bars
     ========================================================= */
  let fotms = [];
  function initFotm() {
    fotms = $$('[data-fotm]').map(el => ({ el, img: $('.fotm__img', el), medals: $$('[data-float]', el) }));
    $$('[data-pyr]').forEach(pyr => {
      if (RM || !once(pyr, 'fbPyr')) return;
      const dds = $$('dd', pyr);
      dds.forEach((d, i) => { d.style.transform = 'scaleX(0)'; d.style.transformOrigin = 'left'; d.style.transition = `transform 1.2s cubic-bezier(.16,1,.3,1) ${0.15 * i}s`; });
      new IntersectionObserver((es, o) => es.forEach(e => { if (e.isIntersecting) { dds.forEach(d => { d.style.transform = ''; }); o.disconnect(); } }), { threshold: 0.5 }).observe(pyr);
    });
  }
  function tickFotm() {
    fotms.forEach(f => {
      if (!f.el.isConnected) return;
      const r = f.el.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return;
      const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
      if (f.img) f.img.style.transform = `translate3d(0,${p * 7 - 8}%,0)`;
      f.medals.forEach(m => { m.style.transform = `translate3d(0,${p * 260 * (+m.dataset.float || 0)}px,0)`; });
    });
  }

  /* =========================================================
     SCENT WHEEL (segments built from editable family blocks)
     ========================================================= */
  function initWheel(root = document) {
    $$('[data-wheel]', root).forEach(sec => {
      if (!once(sec, 'fbWheel')) return;
      const segG = $('[data-wheel-segs]', sec), panel = $('[data-wheel-panel]', sec), wrapW = $('[data-wheel-wrap]', sec), chips = $('[data-wheel-chips]', sec);
      const fams = $$('[data-wheel-data] > li', sec).map(li => ({ li, n: li.dataset.name, s: li.dataset.short || li.dataset.name, t: li.dataset.tint || '#C8A04A', w: li.dataset.words || '', smell: li.dataset.smell || '', tpl: li.querySelector('template') }));
      const N = fams.length; if (!N || !segG) return;
      const CX = 300, CY = 300, R1 = 284, R0 = 152, GAP = N > 1 ? 0.9 : 0;
      const pt = (r, a) => [CX + r * Math.cos(a), CY + r * Math.sin(a)];
      const rad = d => (d - 90) * Math.PI / 180;
      const NS = 'http://www.w3.org/2000/svg';
      let active = -1, userTouched = false;
      segG.innerHTML = ''; chips.innerHTML = '';
      fams.forEach((f, i) => {
        const a0 = i * 360 / N + GAP, a1 = (i + 1) * 360 / N - GAP - (N === 1 ? 0.01 : 0), am = (a0 + a1) / 2;
        const large = (a1 - a0) > 180 ? 1 : 0;
        const [x0, y0] = pt(R1, rad(a0)), [x1, y1] = pt(R1, rad(a1)), [x2, y2] = pt(R0, rad(a1)), [x3, y3] = pt(R0, rad(a0));
        const d = `M${x0} ${y0} A${R1} ${R1} 0 ${large} 1 ${x1} ${y1} L${x2} ${y2} A${R0} ${R0} 0 ${large} 0 ${x3} ${y3}Z`;
        const flip = am > 90 && am < 270, rl = 222;
        const [lx0, ly0] = pt(rl, rad(flip ? a1 - 1 : a0 + 1)), [lx1, ly1] = pt(rl, rad(flip ? a0 + 1 : a1 - 1));
        const lp = `M${lx0} ${ly0} A${rl} ${rl} 0 0 ${flip ? 0 : 1} ${lx1} ${ly1}`;
        const off = [Math.cos(rad(am)) * 16, Math.sin(rad(am)) * 16];
        const pid = 'lp-' + (sec.id || 'w') + '-' + i + '-' + Math.random().toString(36).slice(2, 6);
        const [dx, dy] = pt(262, rad(am));
        const g = document.createElementNS(NS, 'g');
        g.setAttribute('class', 'seg'); g.setAttribute('tabindex', '0'); g.setAttribute('role', 'button');
        g.setAttribute('aria-label', f.n + (f.w ? ': ' + f.w.replace(/ · /g, ', ') : ''));
        g.setAttribute('aria-pressed', 'false');
        g.dataset.off = off.join(',');
        g.innerHTML = `<path d="${d}" fill="${esc(f.t)}" fill-opacity=".9"/><path id="${pid}" d="${lp}" fill="none"/><text dy="4" text-anchor="middle"><textPath href="#${pid}" startOffset="50%">${esc(f.s)}</textPath></text><circle cx="${dx}" cy="${dy}" r="2.5" fill="#15121C" opacity=".55"/>`;
        segG.appendChild(g);
        const sel = () => { userTouched = true; setFam(i); };
        g.addEventListener('mouseenter', () => { if (FINE) sel(); });
        g.addEventListener('click', sel);
        g.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sel(); }
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); userTouched = true; setFam((i + 1) % N); segG.children[(i + 1) % N].focus(); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); userTouched = true; setFam((i + N - 1) % N); segG.children[(i + N - 1) % N].focus(); }
        });
        const b = document.createElement('button'); b.type = 'button'; b.innerHTML = `<i style="background:${esc(f.t)}"></i>${esc(f.n)}`; b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', sel); chips.appendChild(b);
      });
      const nameEl = $('[data-wc-name]', sec), wordsEl = $('[data-wc-words]', sec);
      function noteChips(smell) {
        const part = smell.includes(':') ? smell.split(':').slice(1).join(':') : smell;
        return [...new Set(part.replace(/\.$/, '').split(/,| and /).map(s => s.trim().replace(/\.$/, '')).filter(s => s && s.split(' ').length < 4))].slice(0, 7);
      }
      function setFam(i) {
        if (i === active || !fams[i]) return; active = i; const f = fams[i];
        wrapW && wrapW.classList.add('has-active');
        Array.from(segG.children).forEach((g, j) => {
          const on = j === i; g.classList.toggle('on', on); g.setAttribute('aria-pressed', on);
          const [ox, oy] = g.dataset.off.split(',').map(Number); g.style.transform = on ? `translate(${ox}px,${oy}px)` : '';
        });
        Array.from(chips.children).forEach((b, j) => b.setAttribute('aria-pressed', j === i));
        if (chips.children[i] && userTouched && chips.scrollWidth > chips.clientWidth) {
          const c = chips.children[i]; chips.scrollTo({ left: c.offsetLeft - chips.clientWidth / 2 + c.offsetWidth / 2, behavior: RM ? 'auto' : 'smooth' });
        }
        if (nameEl) nameEl.textContent = f.n; if (wordsEl) wordsEl.textContent = f.w;
        sec.style.setProperty('--fam-glow', f.t + '40');
        if (!panel) return;
        panel.style.opacity = 0;
        setTimeout(() => {
          panel.innerHTML = '';
          if (f.tpl) panel.appendChild(f.tpl.content.cloneNode(true));
          const cbox = $('[data-chips]', panel);
          if (cbox) cbox.innerHTML = noteChips(f.smell).map(n => `<span class="chip">${esc(n)}</span>`).join('');
          const show = () => { panel.style.transition = 'opacity .5s'; panel.style.opacity = 1; };
          Promise.race([Promise.all($$('img', panel).map(im => (im.decode ? im.decode().catch(() => {}) : null))), new Promise(r => setTimeout(r, 400))]).then(show);
          bindCursor(panel);
        }, RM ? 0 : 180);
      }
      sec._setFam = i => { userTouched = true; setFam(i); };
      setFam(clamp(parseInt(sec.dataset.start, 10) || 0, 0, N - 1));
      if (!RM && sec.dataset.tour === 'true' && N > 1) {
        let vis = false;
        new IntersectionObserver(es => { vis = es[0].isIntersecting; }, { threshold: 0.4 }).observe(wrapW || sec);
        sec._tour = setInterval(() => { if (!sec.isConnected) return clearInterval(sec._tour); if (vis && !userTouched && document.visibilityState === 'visible') setFam((active + 1) % N); }, 3800);
      }
    });
  }

  /* =========================================================
     SMELL THE WORLD: pinned horizontal journey
     ========================================================= */
  let journeys = [];
  function initJourney() {
    journeys = $$('[data-journey]').map(el => ({ el, track: $('[data-journey-track]', el), fill: $('[data-route-fill]', el), stops: $$('[data-route-stops] span', el), on: false, max: 0 })).filter(j => j.track);
    sizeJourney();
  }
  function sizeJourney() {
    journeys.forEach(j => {
      j.on = !RM && innerWidth > 980 && j.track.children.length > 1;
      j.el.classList.toggle('is-pinned', j.on);
      if (!j.on) {
        j.el.style.height = ''; j.track.style.transform = '';
        $$('.jp', j.track).forEach(el => { if (el.children[0]) el.children[0].style.opacity = ''; if (el.children[1]) el.children[1].style.opacity = ''; const im = $('.jp__img', el); if (im) im.style.transform = ''; });
        return;
      }
      j.max = Math.max(0, j.track.scrollWidth - innerWidth);
      j.el.style.height = (j.max + innerHeight) + 'px';
    });
  }
  function tickJourney() {
    journeys.forEach(j => {
      if (!j.on || !j.el.isConnected) return;
      const r = j.el.getBoundingClientRect();
      if (r.bottom < -innerHeight || r.top > innerHeight * 2) return;
      const p = clamp(-r.top / Math.max(1, j.el.offsetHeight - innerHeight), 0, 1);
      const panels = Array.from(j.track.children);
      const xs = panels.map((el, i) => (i === 0 ? 0 : clamp(el.offsetLeft + el.offsetWidth / 2 - innerWidth / 2, 0, j.max)));
      let X = 0;
      if (xs.length > 1) {
        const s = p * (xs.length - 1), i = Math.min(xs.length - 2, Math.floor(s)), f = s - i;
        let e = clamp((f - 0.28) / 0.44, 0, 1); e = e < 0.5 ? 4 * e * e * e : 1 - Math.pow(-2 * e + 2, 3) / 2;
        X = lerp(xs[i], xs[i + 1], e);
      }
      j.track.style.transform = `translate3d(${-X}px,0,0)`;
      if (j.fill) j.fill.style.width = (p * 100) + '%';
      j.stops.forEach((st, k) => st.classList.toggle('on', p >= k / Math.max(1, j.stops.length - 1) - 0.06));
      panels.forEach(el => {
        if (el.classList.contains('jp--intro')) return;
        const b = el.getBoundingClientRect(); const c = (b.left + b.width / 2 - innerWidth / 2) / innerWidth;
        const o = 1 - Math.min(1, Math.abs(c) * 1.6) * 0.82;
        if (el.children[0]) el.children[0].style.opacity = o; if (el.children[1]) el.children[1].style.opacity = 0.25 + o * 0.75;
        const img = $('.jp__img', el); if (img) img.style.transform = `translate3d(${c * -60}px,0,0) rotate(${c * -7}deg) scale(${1 - Math.min(0.12, Math.abs(c) * 0.15)})`;
      });
    });
  }
  addEventListener('resize', () => { sizeJourney(); });
  addEventListener('load', () => { sizeJourney(); setAnnH(); });

  /* ---------- main animation loop ---------- */
  (function loop() {
    try { if (!RM) { tickHero(); tickFotm(); } tickJourney(); } catch (err) { /* keep the loop alive */ }
    requestAnimationFrame(loop);
  })();

  /* =========================================================
     SMALL HOME MODULES: marquee, tabs, card notes, campaign
     ========================================================= */
  function initMarquee(root = document) {
    $$('[data-marquee]', root).forEach(tt => {
      if (RM || !once(tt, 'fbMarq') || !tt.firstElementChild) return;
      tt.appendChild(tt.firstElementChild.cloneNode(true)).setAttribute('aria-hidden', 'true');
    });
  }
  function initTabs(root = document) {
    $$('[data-tabs]', root).forEach(sec => {
      if (!once(sec, 'fbTabs')) return;
      const tabs = $$('[role=tab]', sec);
      const select = (t, focus) => {
        tabs.forEach(x => { const on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; const p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
        if (focus) t.focus();
        const p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) { $$('.rv', p).forEach((el, i) => { el.style.transitionDelay = (i % 4) * 70 + 'ms'; }); initReveals(p); bindCursor(p); bindMagnetic(p); }
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', e => {
          let n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i + tabs.length - 1) % tabs.length];
          if (e.key === 'Home') n = tabs[0];
          if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-notes-btn]'); if (!b) return;
    const c = b.closest('.card'); if (!c) return;
    const on = c.classList.toggle('show-notes');
    b.setAttribute('aria-expanded', on);
    b.textContent = on ? (b.dataset.close || 'Close') : (b.dataset.open || 'Notes');
  });
  function initCampaign(root = document) {
    $$('[data-campaign]', root).forEach(sec => {
      if (!once(sec, 'fbCamp')) return;
      const track = $('[data-camp-track]', sec); if (!track) return;
      const step = dir => { const item = track.firstElementChild; const w = item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8; track.scrollBy({ left: dir * w, behavior: RM ? 'auto' : 'smooth' }); };
      const prev = $('[data-camp-prev]', sec), next = $('[data-camp-next]', sec);
      prev && prev.addEventListener('click', () => step(-1));
      next && next.addEventListener('click', () => step(1));
    });
  }

  /* =========================================================
     CART: count, drawer, AJAX add / change / note
     ========================================================= */
  const drawerEl = () => $('[data-cart-drawer]');
  const useDrawer = () => FB.cartType === 'drawer' && !!drawerEl() && !body.classList.contains('tpl-cart');
  let lastFocus = null;
  function updateCount(n) {
    $$('[data-cart-count]').forEach(el => { el.textContent = n; el.dataset.count = n; });
    $$('[data-cart-count-label]').forEach(el => { el.textContent = n; });
    const tpl = +n === 1 ? STR.cartCountOne : STR.cartCountOther;
    if (tpl) $$('[data-cart-open]').forEach(a => { a.setAttribute('aria-label', tpl.replace(+n === 1 ? '1' : '2', n)); });
  }
  function openCart() {
    const d = drawerEl(); if (!d) return;
    if (d.classList.contains('open')) return;
    lastFocus = document.activeElement;
    void d.offsetWidth; /* commit the closed state first, so a freshly swapped panel still slides in */
    d.classList.add('open'); body.classList.add('cart-open'); lock();
    const c = $('[data-cart-close].icon-btn', d) || $('[data-cart-close]', d);
    setTimeout(() => c && c.focus(), 50);
  }
  function closeCart() {
    const d = drawerEl(); if (!d || !d.classList.contains('open')) return;
    d.classList.remove('open'); body.classList.remove('cart-open'); unlock();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function renderDrawer(htmlStr) {
    const d = drawerEl(); if (!d || !htmlStr) return;
    const doc = parse(htmlStr);
    const fresh = $('[data-cart-drawer] .cdrawer__panel', doc), cur = $('.cdrawer__panel', d);
    if (fresh && cur) cur.replaceWith(fresh);
    bindCursor(d);
  }
  function renderCartPage(htmlStr, sid) {
    const wrap = document.getElementById('shopify-section-' + sid); if (!wrap || !htmlStr) return;
    const doc = parse(htmlStr);
    const fresh = $('[data-cart-page]', doc), cur = $('[data-cart-page]', wrap);
    if (fresh && cur) cur.replaceWith(fresh);
  }
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && useDrawer()) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }
  });
  document.addEventListener('keydown', e => {
    const d = drawerEl();
    if (d && d.classList.contains('open')) { if (e.key === 'Escape') closeCart(); else trapFocus(d, e); }
  });

  async function changeLine(scope, line, quantity) {
    const isPage = !!scope.closest('[data-cart-page]');
    const pageSid = isPage ? sectionIdOf(scope) : null;
    const sections = ['cart-drawer'].concat(pageSid ? [pageSid] : []).filter(s => s && (s !== 'cart-drawer' || drawerEl()));
    const holder = isPage ? scope.closest('[data-cart-page]') : drawerEl();
    holder && holder.classList.add('is-loading');
    try {
      const res = await fetch((R.cartChange || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections, sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || STR.error);
      updateCount(data.item_count);
      if (data.sections) {
        if (data.sections['cart-drawer']) renderDrawer(data.sections['cart-drawer']);
        if (pageSid && data.sections[pageSid]) renderCartPage(data.sections[pageSid], pageSid);
      }
    } catch (err) {
      if (isPage) location.reload(); else alert(err.message || STR.error);
    } finally {
      const h = isPage ? $('[data-cart-page]') : drawerEl();
      h && h.classList.remove('is-loading');
      holder && holder.classList.remove('is-loading');
    }
  }
  document.addEventListener('click', e => {
    const q = e.target.closest('[data-cart-qty]');
    const rm = e.target.closest('[data-cart-remove]');
    const t = q || rm; if (!t) return;
    const item = t.closest('.citem'); const scope = t.closest('[data-cart-drawer], [data-cart-page]');
    if (!item || !scope) return;
    e.preventDefault();
    changeLine(scope, +item.dataset.line, rm ? 0 : Math.max(0, +t.dataset.cartQty));
  });
  document.addEventListener('change', e => {
    const inp = e.target.closest('[data-cart-input]');
    if (inp) {
      const item = inp.closest('.citem'); const scope = inp.closest('[data-cart-drawer], [data-cart-page]');
      if (item && scope) changeLine(scope, +item.dataset.line, Math.max(0, parseInt(inp.value, 10) || 0));
      return;
    }
    const note = e.target.closest('[data-cart-note], #cartNote');
    if (note) fetch((R.cartUpdate || '/cart/update') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }).catch(() => {});
  });

  /* ---------- product form: AJAX add to cart ----------
     Capture-phase listener so it runs before any app/script listener on the form can stop the event.
     Flow: clean loading state (spinner, no text swap) -> POST /cart/add.js with the cart-drawer section ->
     swap in the fresh drawer -> open the drawer -> update the count -> dispatch fb:cart:added.
     The drawer opens on every successful add, even if the section HTML or the count refresh fails. */
  const loading = (btns, on) => btns.forEach(b => {
    if (!b) return;
    b.classList.toggle('is-loading', on);
    if (on) { b.style.transform = ''; b.setAttribute('aria-busy', 'true'); b.setAttribute('aria-disabled', 'true'); }
    else { b.removeAttribute('aria-busy'); b.removeAttribute('aria-disabled'); }
    let sr = b.querySelector('.btn__sr');
    if (on && STR.adding) { if (!sr) { sr = document.createElement('span'); sr.className = 'sr-only btn__sr'; b.appendChild(sr); } sr.textContent = STR.adding; }
    else if (sr) sr.remove();
  });
  async function fetchDrawerSection() {
    try { const r = await fetch(`${R.root || '/'}?section_id=cart-drawer`); return r.ok ? await r.text() : ''; } catch (e) { return ''; }
  }
  async function addToCart(form, submitter) {
    const btn = $('[data-add-btn]', form), err = $('[data-form-error]', form);
    const sec = form.closest('[data-product]');
    const sticky = sec && $('[data-sticky-add]', sec);
    if (form.dataset.fbBusy === '1' || (btn && btn.disabled)) return;
    form.dataset.fbBusy = '1';
    loading([btn, sticky], true);
    if (err) { err.hidden = true; err.textContent = ''; }
    let added = false;
    try {
      const fd = new FormData(form);
      if (submitter && submitter.name && !fd.has(submitter.name)) fd.append(submitter.name, submitter.value || '');
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', location.pathname);
      const res = await fetch((R.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.status) throw new Error(data.description || data.message || STR.error);
      added = true;
      let html = data.sections && data.sections['cart-drawer'];
      if (!html) html = await fetchDrawerSection();
      try { renderDrawer(html); } catch (ex) { if (window.console) console.warn('[Fragrances Bazaar theme] drawer render', ex); }
      openCart();
      document.dispatchEvent(new CustomEvent('fb:cart:added', { detail: { item: data } }));
      fetch((R.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(cr => {
        updateCount(cr.item_count);
        document.dispatchEvent(new CustomEvent('fb:cart:updated', { detail: { cart: cr } }));
      }).catch(() => {});
    } catch (ex) {
      if (err) { err.textContent = ex.message || STR.error; err.hidden = false; }
      if (added) openCart();
    } finally {
      loading([btn, sticky], false);
      delete form.dataset.fbBusy;
    }
  }
  document.addEventListener('submit', e => {
    const form = e.target.closest && e.target.closest('[data-product-form]');
    if (!form || !useDrawer()) return;
    e.preventDefault();
    addToCart(form, e.submitter);
  }, true);
  /* v1.1: shared helpers for assets/discovery.js (Layer it with, Compare, Smells-like). */
  FB.api = { renderDrawer, openCart, updateCount, fetchDrawerSection, useDrawer, loading, formatMoney: (c, f) => formatMoney(c, f), bindCursor: r => bindCursor(r), esc };
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-product-form] [data-qty]'); if (!b) return;
    const inp = $('input[name=quantity]', b.closest('form')); if (!inp) return;
    inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + (+b.dataset.qty));
  });

  /* =========================================================
     PRODUCT PAGE: variants, gallery, sticky ATC
     ========================================================= */
  function initProduct(root = document) {
    $$('[data-product]', root).forEach(sec => {
      if (!once(sec, 'fbPdp')) return;
      const sid = sec.dataset.sectionId;
      const picker = $('[data-variant-picker]', sec);
      const form = $('[data-product-form]', sec);
      const track = $('[data-gallery-track]', sec);
      const thumbs = $$('[data-thumb]', sec);

      /* gallery */
      const goMedia = id => {
        const fr = track && $(`[data-media-id="${id}"]`, track); if (!fr) return;
        track.scrollTo({ left: fr.offsetLeft - track.offsetLeft, top: track.scrollWidth > track.clientWidth ? 0 : fr.offsetTop - track.offsetTop, behavior: RM ? 'auto' : 'smooth' });
        thumbs.forEach(t => t.toggleAttribute('aria-current', t.dataset.thumb === String(id)));
      };
      thumbs.forEach(t => t.addEventListener('click', () => goMedia(t.dataset.thumb)));
      if (track && thumbs.length) {
        let raf;
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const frames = $$('[data-media-id]', track);
            const mid = track.scrollLeft + track.clientWidth / 2;
            let best = frames[0], bd = Infinity;
            frames.forEach(f => { const c = f.offsetLeft - track.offsetLeft + f.offsetWidth / 2; const d = Math.abs(c - mid); if (d < bd) { bd = d; best = f; } });
            if (best && track.scrollWidth > track.clientWidth + 2) thumbs.forEach(t => t.toggleAttribute('aria-current', t.dataset.thumb === best.dataset.mediaId));
          });
        }, { passive: true });
      }

      /* variants */
      if (picker && form) {
        const json = $('script[data-variants]', picker);
        const variants = json ? JSON.parse(json.textContent) : [];
        const idInput = $('[data-variant-id]', form);
        const btn = $('[data-add-btn]', form), label = $('[data-add-label]', form);
        const stickyBtn = $('[data-sticky-add]', sec), stickyPrice = $('[data-sticky-price]', sec);
        const selected = () => {
          const opts = [];
          $$('select[data-option-index]', picker).forEach(s => { opts[+s.dataset.optionIndex] = s.value; });
          $$('input[type=radio][data-option-index]:checked', picker).forEach(r => { opts[+r.dataset.optionIndex] = r.value; });
          return opts;
        };
        const onChange = () => {
          const opts = selected();
          opts.forEach((v, i) => { const l = $(`[data-option-label="${i}"]`, picker); if (l) l.textContent = v; });
          const v = variants.find(x => x.options.every((o, i) => o === opts[i]));
          if (!v) {
            if (btn) btn.disabled = true; if (label) label.textContent = STR.unavailable || 'Unavailable';
            if (stickyBtn) stickyBtn.disabled = true; return;
          }
          if (idInput) idInput.value = v.id;
          if (btn) btn.disabled = !v.available;
          if (label) label.textContent = v.available ? (STR.addToCart || 'Add to cart') : (STR.soldOut || 'Sold out');
          if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? (STR.addToCart || 'Add to cart') : (STR.soldOut || 'Sold out'); }
          if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
          if (v.featured_media && v.featured_media.id) goMedia(v.featured_media.id);
          const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
          if (sid) {
            fetch(`${location.pathname}?variant=${v.id}&section_id=${encodeURIComponent(sid)}`).then(r => r.text()).then(t => {
              const doc = parse(t);
              const np = $('[data-price]', doc), cp = $('[data-price]', sec);
              if (np && cp) cp.innerHTML = np.innerHTML;
            }).catch(() => {
              const cp = $('[data-price] .price__now', sec); if (cp) cp.textContent = formatMoney(v.price);
            });
          }
        };
        picker.addEventListener('change', onChange);
      }

      /* sticky add-to-cart */
      const sticky = $('[data-sticky-atc]', sec), buyBtn = form && $('[data-add-btn]', form);
      if (sticky && buyBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(es => {
          const e = es[0]; const past = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('show', past); sticky.setAttribute('aria-hidden', !past);
          // let other bottom-fixed UI (compare tray, WhatsApp button) sit above the bar while it shows
          const onBar = past && getComputedStyle(sticky).display !== 'none';
          document.body.classList.toggle('has-sticky-atc', onBar);
          if (onBar) document.documentElement.style.setProperty('--sticky-atc-h', sticky.offsetHeight + 'px');
          const sb = $('[data-sticky-add]', sticky); if (sb) sb.tabIndex = past ? 0 : -1;
        }).observe(buyBtn);
        const sb = $('[data-sticky-add]', sticky);
        sb && sb.addEventListener('click', () => { if (useDrawer()) addToCart(form, buyBtn); else if (form.requestSubmit) form.requestSubmit(buyBtn); else buyBtn.click(); });
      }
    });
  }

  /* ---------- product recommendations ---------- */
  function initRecs(root = document) {
    $$('[data-recs]', root).forEach(el => {
      if (!el.dataset.url || !once(el, 'fbRecs')) return;
      const load = () => fetch(el.dataset.url).then(r => r.text()).then(t => {
        const fresh = $('[data-recs]', parse(t));
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initReveals(el); bindCursor(el); bindMagnetic(el); }
      }).catch(() => {});
      if ('IntersectionObserver' in window) new IntersectionObserver((es, o) => { if (es[0].isIntersecting) { o.disconnect(); load(); } }, { rootMargin: '600px' }).observe(el);
      else load();
    });
  }

  /* =========================================================
     PREDICTIVE SEARCH
     ========================================================= */
  function initPredictive() {
    const ov = $('#psearch'), input = $('#psearchInput'), res = $('#psearchRes');
    if (!ov || !input || !res || !once(ov, 'fbPs')) return;
    let last = '', t, ctrl, opener = null;
    const open = () => { opener = document.activeElement; ov.classList.add('open'); body.classList.add('psearch-open'); lock(); setTimeout(() => input.focus(), 60); };
    const close = () => { if (!ov.classList.contains('open')) return; ov.classList.remove('open'); body.classList.remove('psearch-open'); unlock(); if (opener && opener.focus) opener.focus(); };
    document.addEventListener('click', e => {
      if (e.target.closest('[data-psearch-open]') && FB.predictive !== false) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-psearch-close]')) { e.preventDefault(); close(); }
      else if (e.target === ov) close();
    });
    ov.addEventListener('keydown', e => { if (e.key === 'Escape') close(); else trapFocus(ov, e); });
    const run = () => {
      const q = input.value.trim();
      if (q === last) return; last = q;
      if (q.length < 2) { res.innerHTML = ''; return; }
      if (ctrl) ctrl.abort(); ctrl = new AbortController();
      const url = `${R.predictive || '/search/suggest'}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,article,page,query&resources[limit]=6&resources[options][unavailable_products]=last`;
      ov.classList.add('is-loading');
      fetch(url, { signal: ctrl.signal }).then(r => r.text()).then(txt => {
        const doc = parse(txt);
        const sec = $('#shopify-section-predictive-search', doc) || doc.body;
        res.innerHTML = sec.innerHTML;
        bindCursor(res);
      }).catch(() => {}).finally(() => ov.classList.remove('is-loading'));
    };
    input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(run, 240); });
  }

  /* =========================================================
     COLLECTION / SEARCH FILTERS
     ========================================================= */
  document.addEventListener('change', e => {
    const el = e.target.closest('[data-facets-autosubmit]'); if (!el) return;
    const form = el.form || (el.getAttribute('form') && document.getElementById(el.getAttribute('form')));
    if (!form) return;
    if (window.innerWidth < 980 && form.classList.contains('open') && el.closest('.facets')) return; /* mobile: apply button */
    $$('input, select', form).forEach(i => { if ((i.type === 'number' || i.type === 'text') && !i.value) i.disabled = true; });
    form.submit();
  });
  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-facets-form]'); if (!form) return;
    $$('input', form).forEach(i => { if ((i.type === 'number' || i.type === 'text') && !i.value) i.disabled = true; });
  });
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-facets-open]');
    if (o) { const f = document.getElementById(o.getAttribute('aria-controls')); if (f) { f.hidden = false; f.classList.add('open'); body.classList.add('facets-open'); lock(); o.setAttribute('aria-expanded', 'true'); const c = $('[data-facets-close]', f); c && c.focus(); } return; }
    const c = e.target.closest('[data-facets-close]');
    if (c) { const f = c.closest('.facets'); if (f) { f.classList.remove('open'); body.classList.remove('facets-open'); unlock(); const ob = $('[data-facets-open]'); if (ob) { ob.setAttribute('aria-expanded', 'false'); ob.focus(); } } }
  });

  /* =========================================================
     FIND YOUR SCENT QUIZ
     ========================================================= */
  /* v1.1 gift mode: answers/questions switch to third person ("you" -> "they") unless the block has its own gift wording. */
  const toThey = str => String(str)
    .replace(/\b(like|make|makes|for|with|to|suits|help) you\b/gi, (m, w) => w + ' them')
    .replace(/\byou're\b/g, "they're").replace(/\bYou're\b/g, "They're")
    .replace(/\byourself\b/gi, 'themselves')
    .replace(/\byour\b/g, 'their').replace(/\bYour\b/g, 'Their')
    .replace(/\byou\b/g, 'they').replace(/\bYou\b/g, 'They');
  function initQuiz(root = document) {
    $$('[data-quiz]', root).forEach(q => {
      if (!once(q, 'fbQuiz')) return;
      const intro = $('[data-quiz-intro]', q), bar = $('[data-quiz-bar]', q), barI = bar && bar.querySelector('i');
      const steps = $$('[data-quiz-step]', q), results = $$('[data-quiz-result]', q);
      const picks = new Array(steps.length).fill(null);
      let cur = -1, mode = 'self';
      const order = results.map(r => r.dataset.quizResult);
      const setMode = m => {
        mode = m === 'gift' ? 'gift' : 'self';
        q.classList.toggle('is-gift', mode === 'gift'); q.dataset.mode = mode;
        $$('.fq__q, .fq__ans button', q).forEach(el => {
          if (el.dataset.self == null) el.dataset.self = el.textContent;
          el.textContent = mode === 'gift' ? (el.dataset.gift || toThey(el.dataset.self)) : el.dataset.self;
        });
        $$('[data-quiz-mode]', q).forEach(b => b.setAttribute('aria-pressed', b.dataset.quizMode === mode));
      };
      const show = i => {
        cur = i;
        [intro, ...steps, ...results].forEach(el => el && el.classList.remove('on'));
        if (i < 0) { intro && intro.classList.add('on'); if (bar) bar.hidden = true; return; }
        if (bar) { bar.hidden = false; barI.style.width = (i / steps.length * 100) + '%'; }
        const st = steps[i]; st.classList.add('on');
        const back = $('[data-quiz-back]', st); if (back) back.style.visibility = i === 0 ? 'hidden' : 'visible';
        const first = st.querySelector('button[aria-pressed=true]') || st.querySelector('.fq__ans button'); first && first.focus({ preventScroll: true });
        if (q.getBoundingClientRect().top < 0) q.scrollIntoView({ behavior: RM ? 'auto' : 'smooth' });
      };
      const tally = () => {
        const sc = {};
        picks.forEach(str => { if (!str) return; str.split(',').forEach(pair => { const [k, v] = pair.split(':').map(s => s && s.trim().toLowerCase()); if (k) sc[k] = (sc[k] || 0) + (parseFloat(v) || 1); }); });
        return order.map((k, i) => ({ k, s: sc[k] || 0, i })).sort((a, b) => b.s - a.s || a.i - b.i);
      };
      const showRes = (k, runner, silent) => {
        [intro, ...steps].forEach(el => el && el.classList.remove('on'));
        if (bar && barI) { bar.hidden = false; barI.style.width = '100%'; }
        results.forEach(r => r.classList.toggle('on', r.dataset.quizResult === k));
        const r = results.find(x => x.dataset.quizResult === k); if (!r) return;
        const also = $('[data-quiz-also]', r), link = $('[data-quiz-also-link]', r);
        const ru = runner && results.find(x => x.dataset.quizResult === runner.k);
        if (also && link && ru && runner.s > 0) {
          also.hidden = false; link.textContent = ru.dataset.name; link.onclick = ev => { ev.preventDefault(); showRes(runner.k, { k, s: 1 }); };
        } else if (also) also.hidden = true;
        bindCursor(r);
        const shop = $('.fq__ctas a[href]', r);
        const detail = { key: k, name: r.dataset.name || k, url: r.dataset.url || (shop ? shop.getAttribute('href') : ''), runner: ru && runner.s > 0 ? runner.k : '', runnerName: ru && runner.s > 0 ? ru.dataset.name : '', mode, quiz: q };
        q._fbLast = detail;
        if (!silent) document.dispatchEvent(new CustomEvent('fb:quiz:result', { detail }));
        const h = r.querySelector('h2'); h && h.focus({ preventScroll: true });
        if (q.getBoundingClientRect().top < 0) q.scrollIntoView({ behavior: RM ? 'auto' : 'smooth' });
      };
      const finish = () => { const ranked = tally(); if (ranked.length) showRes(ranked[0].k, ranked[1]); };
      /* lets discovery.js re-open a saved result (e.g. after the "email me my matches" form reloads the page) */
      q._fbShowResult = (k, m, runnerKey) => { setMode(m); showRes(k, runnerKey ? { k: runnerKey, s: 1 } : null, true); };
      const start = $('[data-quiz-start]', q); start && start.addEventListener('click', () => { setMode('self'); show(0); });
      $$('[data-quiz-mode]', q).forEach(b => b.addEventListener('click', () => { setMode(b.dataset.quizMode); show(0); }));
      steps.forEach((st, i) => {
        $$('.fq__ans button', st).forEach(b => b.addEventListener('click', () => {
          $$('.fq__ans button', st).forEach(x => x.setAttribute('aria-pressed', x === b));
          picks[i] = b.dataset.scores || '';
          setTimeout(() => { if (i + 1 < steps.length) show(i + 1); else finish(); }, RM ? 0 : 260);
        }));
        const back = $('[data-quiz-back]', st); back && back.addEventListener('click', () => show(Math.max(-1, i - 1)));
      });
      $$('[data-quiz-restart]', q).forEach(b => b.addEventListener('click', () => { picks.fill(null); $$('.fq__ans button', q).forEach(x => x.setAttribute('aria-pressed', 'false')); show(-1); }));
      if (DESIGN && cur === -1) intro && intro.classList.add('on');
    });
  }

  /* =========================================================
     NEWSLETTER, CUSTOMER UTILITIES
     ========================================================= */
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-newsletter]'); if (!f) return;
    const inp = $('input[type=email]', f), msg = $('.nl-msg', f);
    if (inp && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value.trim())) {
      e.preventDefault();
      if (msg) { msg.textContent = STR.newsletterInvalid || 'Please enter a valid email address.'; msg.classList.add('nl-msg--err'); }
      inp.setAttribute('aria-invalid', 'true'); inp.focus();
    }
  });
  document.addEventListener('click', e => {
    const c = e.target.closest('[data-confirm]');
    if (c && !confirm(c.dataset.confirm)) e.preventDefault();
  });
  function initCustomer() {
    $$('select[data-default]').forEach(s => { if (s.dataset.default) s.value = s.dataset.default; });
  }

  /* =========================================================
     WHATSAPP BUTTON: hide over footer legal row (keeps credit visible)
     ========================================================= */
  function initWhatsApp() {
    const fab = $('.wa-fab'), legal = $('.ftr__legal');
    if (!fab || !legal || !('IntersectionObserver' in window)) return;
    if (window.__fbWaIO) window.__fbWaIO.disconnect();
    window.__fbWaIO = new IntersectionObserver(es => { fab.classList.toggle('is-hidden', es[0].isIntersecting); }, { threshold: 0 });
    window.__fbWaIO.observe(legal);
  }

  /* =========================================================
     INIT + THEME EDITOR
     ========================================================= */
  /* Each module is isolated: one failing module (or an app's markup it does not expect) never stops the rest. */
  function initAll(root = document) {
    [() => initHeader(), () => initReveals(root), () => initHero(), () => initFotm(), () => initWheel(root), () => initJourney(),
      () => initMarquee(root), () => initTabs(root), () => initCampaign(root), () => initProduct(root), () => initRecs(root),
      () => initPredictive(), () => initQuiz(root), () => initCustomer(), () => initWhatsApp(),
      () => bindMagnetic(root), () => bindCursor(root)].forEach(fn => {
      try { fn(); } catch (err) { if (window.console) console.warn('[Fragrances Bazaar theme]', err); }
    });
  }
  initAll();
  window.__fbThemeReady = true;

  document.addEventListener('shopify:section:load', e => { initAll(e.target); });
  document.addEventListener('shopify:section:unload', e => { $$('[data-wheel]', e.target).forEach(w => w._tour && clearInterval(w._tour)); setTimeout(() => { initHero(); initFotm(); initJourney(); }, 0); });
  document.addEventListener('shopify:block:select', e => {
    const blk = e.target;
    const wheel = blk.closest('[data-wheel]');
    if (wheel && wheel._setFam && blk.parentElement) { const i = Array.from(blk.parentElement.children).indexOf(blk); if (i > -1) wheel._setFam(i); }
    const li = blk.closest('.has-mega'); if (li) li.classList.add('open');
    const camp = blk.closest('[data-camp-track]'); if (camp) camp.scrollTo({ left: blk.offsetLeft - camp.offsetLeft, behavior: 'smooth' });
    const tab = blk.matches && blk.matches('[role=tabpanel]') ? blk : null; if (tab) { const t = document.getElementById(tab.getAttribute('aria-labelledby')); t && t.click(); }
  });
  document.addEventListener('shopify:block:deselect', e => { const li = e.target.closest('.has-mega'); if (li) li.classList.remove('open'); });
})();
